import {handleActions} from "redux-actions";
import api_actions from '../actions/api';
import actions from '../actions/lists';
import _ from "lodash";

const mapList= (list = {}) =>_.keys(list).map(key => ({key, value: list[key].length > 40 ? list[key].substring(0, 40) + '...' : list[key]}))

export default handleActions({
    [actions.lists_get]: (state, action) => {
        switch (action.payload) {
            case api_actions.api_start:
                return {
                    ...state, isLoading: true, errors: {}
                };
            case api_actions.api_end:
                return {
                    ...state, isLoading: false
                };
            default:
                return state;
        }
    },
    [actions.lists_succeeded]: (state, action) => {
        const {lists, product} = action.payload;
        const newLists = _.keys(lists).reduce((acc, key) => {
            const list = lists[key]
            if(!list) return acc
            return {...acc, [key]: mapList(list) }
        }, {})
        return {
            ...state,
            [product]: newLists
        }
    },
    [actions.lists_failed]: (state, action) => {
        const errors = _.get(action, 'payload.data.error');

        return {
            ...state,
            errors: {errors: !_.isEmpty(errors) ? errors : _.get(action, 'payload.data.message') || 'Impossible to get lists'}
        }
    }
}, getDefaults())

function getDefaults() {
    return {
        isLoading: false,
        errors: {},
    }
}